import { LegalDocumentScreen } from '@/modules/legal/components/LegalDocumentScreen';
import { router, useLocalSearchParams } from 'expo-router';
import React from 'react';

export default function TermsAndConditionsScreen() {
    const params = useLocalSearchParams<{ from?: string }>();
    
    const handleAccept = () => {
        // If coming from payment summary, navigate back with param to indicate acceptance
        if (params.from === 'payment-summary') {
            // Get the selectedPaymentIds from the navigation state or use current params
            // We'll navigate back and let the payment summary screen handle the param
            router.back();
            // Use a small delay to ensure navigation completes, then update params
            setTimeout(() => {
                router.setParams({ tncAccepted: 'true' } as any);
            }, 100);
        } else {
            // Navigate back normally
            router.back();
        }
    };

    return (
        <LegalDocumentScreen
            documentName="terms-and-conditions"
            {...(params.from === 'payment-summary' ? { onAccept: handleAccept } : {})}
            {...(params.from ? { from: params.from } : {})}
        />
    );
}

